// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17EcC","importantInfo":"styles_importantInfo__3bN3-"};